module.exports = __webpack_public_path__ + "mx.svg?7fd6e432473edd8abb2611ae2ce5dad3";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/mx.svg
// module id = 1139
// module chunks = 27